module.exports = __webpack_public_path__ + "static/media/anonymous-avatar.fbbfa4f9.png";